<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" closeable :close-on-click-overlay="false" close-icon="clear"
               @closed="onClosed">
      <div class="flex column main">
        <div class="flex1 flex column overflow-hidden">
          <v-tabs :data="tabs" class="flex0" @change="onChange" ref="tabs"></v-tabs>
          <div class="flex1 overflow-y-auto pl15 pr15 pt15 pb15" v-if="currTab==='待完成'">
            <div class="bg item flex color_555 pl15 pr15 pt15 pb15"
                 :class="{mt15:index}"
                 v-for="(item,index) in dwcList" :key="index">
              <p class="flex1">
                项目名称：{{ item.itemName }}<br/>
                <!--                地址：
                                <template v-if="item.inspectAddress">{{ item.inspectAddress }}</template>
                                <template v-else>{{ item.inspectAddressList|getAddress }}</template>-->
              </p>
              <p class="flex0 color_main ml15">{{ item.status|getStatus(item.type) }}</p>
            </div>
            <no-data v-if="dwcList.length===0" text="您没有待完成的项目"></no-data>
          </div>
          <div class="flex1 overflow-y-auto pl15 pr15 pt15 pb15" v-if="currTab==='全部'">
            <div class="bg item flex color_555 pl15 pr15 pt15 pb15"
                 :class="{mt15:index}"
                 v-for="(item,index) in allList" :key="index">
              <p class="flex1">
                项目名称：{{ item.itemName }}<br/>
                <!--                地址：
                                <template v-if="item.inspectAddress">{{ item.inspectAddress }}</template>
                                <template v-else>{{ item.inspectAddressList|getAddress }}</template>-->
              </p>
              <p class="flex0 color_main ml15">{{ item.status|getStatus(item.type) }}</p>
            </div>
            <no-data v-if="allList.length===0" text="暂无检验检查数据"></no-data>
          </div>
        </div>
        <div class="footer flex0 pl30 pr30 pb15 pt15">
          <van-button type="info" class="mb10" v-if="dwcList.length" block round @click="onClick('confirm')">
            生成导诊单
          </van-button>
          <div class="color_999">
            <p v-for="(item,index) in list" :key="index" v-html="item"></p>
          </div>
          <div class="tar color_main" @click="handlerShowAll">{{ showAll ? '收起' : '查看全部' }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import VTabs from "@/plugins/v-tabs";
import NoData from "@/plugins/no-data";
import {isEmpty} from "@/lib/util";
import {dhry_jc_status, dhry_jy_status, handlerDhryAddressList} from "@/page/dhry/config";

const noticeHTML = [
  '温馨提示：',
  // '1、住院当天需持<span class="color_red">48H内浙江省内核酸阴性报告</span>方可入住病房。',
  '1、医院实行无纸化，检查检验报告无需取回，点击“报告查询”可查看',
  '2、部分项目的完成情况未上传，请以自身是否完成为准',
  '3、部分检查/检验项目仅限特定院区可做',
  '4、已预约的检查请按预约时间前往指定地点进行检查，过期作废（需医生重新开立检查并预约）',
  '5、请仔细阅读“注意事项”',
]


export default {
  name: "confirm",
  filters: {
    getStatus(status, type) {
      // 	0-检验 1-检查
      if (type == 0) return dhry_jy_status[status] || status;
      if (type == 1) return dhry_jc_status[status] || status;
      return `${type}-${status}`
    },
    getAddress(list) {
      if (Array.isArray(list)) {
        return handlerDhryAddressList(list)[0]
      }
      return list;
    }
  },
  components: {NoData, VTabs},
  data() {
    return {
      showAll: false,
      currTab: '待完成',
      tabs: [{label: '待完成'}, {label: '全部'}],
      title: "",
      active: 0,
      message: "",
      icon: '',
      dwcList: [],
      allList: [],
      confirmBtnText: "我知道了",
      showTag: false
    }
  },

  computed: {
    list() {
      return noticeHTML.slice(0, this.showAll ? noticeHTML.length : 3);
    }
  },

  methods: {
    handlerShowAll() {
      this.showAll = !this.showAll;
    },

    open() {
      this.showTag = true;
      this.$nextTick(() => {
        let curr = 0
        if (this.allList.length > 0 && this.dwcList.length === 0) {
          curr = 1;
        } else if (this.dwcList.length === 0 && this.allList.length === 0) {
          curr = -1;
        }
        Log('dh-jyjc:curr', curr);
        this.$refs.tabs.setCurr(curr);
      })
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      this.$emit('closed', this.type, this.dwcList /*this.currTab === '待完成' ? this.dwcList : this.allList*/);
    },
    onClick(type) {
      this.type = type;
      this.close()
    },
    onChange(data) {
      // Log('data111111111111', data);
      if (isEmpty(data)) return;
      this.currTab = data.label;
    }
  },
}
</script>

<style scoped lang="scss">
.main {
  max-height: 70vh;
}

.item {
  align-items: flex-start;
}

</style>



// WEBPACK FOOTER //
// src/plugins/dialog/dh-jcjy.vue